module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day03_04_stay-2b85f8c4e836fd40e51f6938fc169556.jpg";